import { styled } from '@mui/material';
import { ReactNode } from 'react';

function PageLayout(props: { children: ReactNode; hideFrieze: boolean | undefined }) {
    return (
        <Container>
            {!props.hideFrieze && <LeftFrise className="not-printable" />}
            <ChildrenContainer>{props.children}</ChildrenContainer>
            {!props.hideFrieze && <RightFrise className="not-printable" />}
        </Container>
    );
}

export { PageLayout };

const LeftFrise = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: { display: 'none' },
    width: '8vw',
    backgroundSize: 'contain',
    backgroundRepeat: 'repeat-y',
    backgroundImage:
        'url(https://res.cloudinary.com/dsbb0ado2/image/upload/v17510180469/frise_pzembf.png)',
}));
const RightFrise = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: { display: 'none' },
    width: '8vw',
    backgroundRepeat: 'repeat-y',
    backgroundSize: 'contain',
    backgroundImage:
        'url(https://res.cloudinary.com/dsbb0ado2/image/upload/v1752180469/frise_pzembf.png)',
}));
const Container = styled('div')(({ theme }) => ({
    height: '100%',
    width: '100vw',
    display: 'flex',
}));
const ChildrenContainer = styled('div')(({ theme }) => ({
    minHeight: `100vh`,
    display: 'flex',

    flex: 1,
}));
